import { TgMailing } from "@/modules/telegram/interfaces"
import {
  parseChatIdLike,
  parseMessageIds,
  CHAT_ID_FORMAT_ERROR,
} from "../../../constants/mailing"
import type { IMailingFormData } from "./mailingForm"

export const buildPagedRequest = (
  data: IMailingFormData,
): {
  request: TgMailing.CreateMailingInitData
  recipients: TgMailing.CallApiBody[]
  useMtProto: boolean
} => {
  const { credentials = "", method, body, speed, ...rest } = data
  const normalizeBody = (
    m: TgMailing.AvailableMethods,
    b: IMailingFormData["body"],
  ) => {
    if (!TgMailing.isMtprotoMethod(m)) return b
    const raw = b as unknown as {
      message_ids: unknown
      from_chat_id: unknown
      [k: string]: unknown
    }
    return {
      ...b,
      from_chat_id: parseChatIdLike(raw.from_chat_id),
      message_ids: parseMessageIds(raw.message_ids),
    } as IMailingFormData["body"]
  }
  const normalizedBody = normalizeBody(method, body)
  const recipients: TgMailing.CallApiBody[] = []
  for (const rawCredential of credentials.split(/\s|,|;/g)) {
    const str = rawCredential.trim()
    if (!str) continue
    const [token, chatIdRaw] = str.split("/")
    const chat_id = parseChatIdLike(chatIdRaw)
    if (chat_id === undefined) {
      throw new Error(`${CHAT_ID_FORMAT_ERROR} (получено: "${chatIdRaw}")`)
    }
    recipients.push({
      token,
      method,
      body: { ...normalizedBody, chat_id } as TgMailing.CallApiBody["body"],
    })
  }
  return {
    request: {
      ...rest,
      speed:
        speed != null && (speed as unknown) !== "" ? Number(speed) : undefined,
    },
    recipients,
    useMtProto: TgMailing.isMtprotoMethod(method),
  }
}
